import * as React from 'react';
import {WithStyles, withStyles} from '@material-ui/core';
import WarningIcon from '@material-ui/icons/WarningRounded';
import TranslateNew from '@translate/TranslateNew';
import { IEvent } from '@app-types/websocket/event.types';
import { styleColors } from 'src/main.style';
import { EditEventStyle } from './EditEvent.style';

const tn: TranslateNew = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof EditEventStyle> {
  overlaps:IEvent[];
}

function EventOverlapWarning({classes, overlaps}:IProps) {
  return (
    <div className={classes.overlapWarning+(overlaps.length === 0?(" "+classes.overlapWarningHidden):"")}>
      <div className={classes.overlapTitle}>
        <WarningIcon style={{fontSize:'15px', color:styleColors.primaryTextBlack87}}/>
        <span>{tn.lang.calEventOverlap(overlaps.length)}</span>
      </div>
      {overlaps.map((ev) => (
        <div className={classes.overlapItem} key={ev.id}>
          <span className={classes.overlapItemTitle}>{ev.title}</span>
          <span className={classes.overlapItemTime}>{overlapTimeLabel(ev)}</span>
        </div>
      ))}
    </div>
  );
}

function overlapTimeLabel(ev:IEvent):string {
  if (!ev.hasTime) {
    return tn.lang.timePickerFullDay;
  }
  return tn.formatTime(new Date(ev.startTime)) + " – " + tn.formatTime(new Date(ev.endTime));
}

export default withStyles(EditEventStyle)(EventOverlapWarning);



// WEBPACK FOOTER //
// ./src/components/calendar2/eventdetails/EventOverlapWarning.tsx